import React from 'react';
import ReactGridLayout from 'react-grid-layout';
import AutoSizer from 'react-virtualized-auto-sizer';
import { GRID_CELL_VMARGIN, GRID_COLUMN_COUNT, GRID_CELL_HEIGHT } from './constants.js';
import { LazyLoader } from './LazyLoader.js';

function SceneGridLayoutRenderer({ model }) {
  const { children, isLazy, isDraggable, isResizable } = model.useState();
  validateChildrenSize(children);
  return /* @__PURE__ */ React.createElement(AutoSizer, {
    disableHeight: true
  }, ({ width }) => {
    if (width === 0) {
      return null;
    }
    const layout = model.buildGridLayout(width);
    return /* @__PURE__ */ React.createElement("div", {
      style: { width: `${width}px`, height: "100%" }
    }, /* @__PURE__ */ React.createElement(ReactGridLayout, {
      width,
      isDraggable: isDraggable && width > 768,
      isResizable: isResizable != null ? isResizable : false,
      containerPadding: [0, 0],
      useCSSTransforms: false,
      margin: [GRID_CELL_VMARGIN, GRID_CELL_VMARGIN],
      cols: GRID_COLUMN_COUNT,
      rowHeight: GRID_CELL_HEIGHT,
      draggableHandle: `.grid-drag-handle-${model.state.key}`,
      draggableCancel: ".grid-drag-cancel",
      layout,
      onDragStop: model.onDragStop,
      onResizeStop: model.onResizeStop,
      onLayoutChange: model.onLayoutChange,
      isBounded: false
    }, layout.map((gridItem) => {
      var _a;
      const sceneChild = model.getSceneLayoutChild(gridItem.i);
      const className = (_a = sceneChild.getClassName) == null ? void 0 : _a.call(sceneChild);
      return isLazy ? /* @__PURE__ */ React.createElement(LazyLoader, {
        key: sceneChild.state.key,
        "data-griditem-key": sceneChild.state.key,
        className
      }, /* @__PURE__ */ React.createElement(sceneChild.Component, {
        model: sceneChild,
        key: sceneChild.state.key
      })) : /* @__PURE__ */ React.createElement("div", {
        key: sceneChild.state.key,
        "data-griditem-key": sceneChild.state.key,
        className
      }, /* @__PURE__ */ React.createElement(sceneChild.Component, {
        model: sceneChild,
        key: sceneChild.state.key
      }));
    })));
  });
}
function validateChildrenSize(children) {
  if (children.some(
    (c) => c.state.height === void 0 || c.state.width === void 0 || c.state.x === void 0 || c.state.y === void 0
  )) {
    throw new Error("All children must have a size specified");
  }
}

export { SceneGridLayoutRenderer };
//# sourceMappingURL=SceneGridLayoutRenderer.js.map
